module.exports = __webpack_public_path__ + "static/bmc-button-40242a959afa7680cff9cb33ce9692a7.png";